"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.xTokensHelper = void 0;
const is_chain_equal_1 = require("./is-chain-equal");
const xcm_versioned_multilocation_check_1 = require("./xcm-versioned-multilocation-check");
const errors_1 = require("../errors");
const buildV1orV3Destination = (api, accountId, toChain) => {
    const supportsV1 = (0, xcm_versioned_multilocation_check_1.supportsV0V1Multilocation)(api);
    const isToRelayChain = (0, is_chain_equal_1.isChainEqual)(toChain, "kusama") || (0, is_chain_equal_1.isChainEqual)(toChain, "polkadot");
    const accountIdPart = supportsV1
        ? { AccountId32: { id: accountId, network: "Any" } }
        : { AccountId32: { id: accountId } };
    const interiorPart = isToRelayChain
        ? { interior: { X1: accountIdPart } }
        : {
            interior: {
                X2: [{ Parachain: toChain.paraChainId }, accountIdPart],
            },
        };
    const destPart = {
        parents: 1,
        ...interiorPart,
    };
    return supportsV1 ? { V1: destPart } : { V3: destPart };
};
const supportsUnlimitedDestWeight = (api) => api.tx.xTokens.transfer.meta.args[3].type.toString() === "XcmV2WeightLimit" ||
    api.tx.xTokens.transfer.meta.args[3].type.toString() === "XcmV3WeightLimit";
exports.xTokensHelper = {
    transfer: (api, fromChain, toChain, accountId, tokenName, tokenId, amount, configuredDestWeight) => {
        const dst = buildV1orV3Destination(api, accountId, toChain);
        const destWeight = supportsUnlimitedDestWeight(api)
            ? "Unlimited"
            : configuredDestWeight;
        if (destWeight === undefined) {
            throw new errors_1.DestinationWeightNotFound(fromChain.id, toChain.id, tokenName);
        }
        return api.tx.xTokens.transfer(tokenId, amount.toChainData(), dst, destWeight);
    },
};
